module.exports = __webpack_public_path__ + "img/第2章_1-1_南山寺紙條.jpg";